import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import defaultStyles from './user-summary-info.scss';

export interface Props {
    styles: typeof defaultStyles;
    name?: string;
    age?: number;
}

function UserSummaryInfo(props: Props) {
    const { styles, name, age } = props;

    if (name === undefined && age === undefined) {
        return null;
    }

    return (
        <div className={styles.name}>
            {name}
            {age ? (
                <React.Fragment>
                    &nbsp; / &nbsp;
                    <FormattedMessage id='%(number)s_YEARS' values={{ number: age }} />
                </React.Fragment>
            ) : null}
        </div>
    );
}

export default Styled(defaultStyles)(UserSummaryInfo);
